import React, { useState } from "react";

export default function Chatbot() {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");

    const sendMessage = async () => {
        if (!input) return;
        const userMessage = { role: "user", content: input };
        setMessages([...messages, userMessage]);

        const res = await fetch("/api/chat", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ message: input }),
        });
        const data = await res.json();
        setMessages([...messages, userMessage, { role: "assistant", content: data.reply }]);
        setInput("");
    };

    return (
        <div className="chatbot">
            <div className="messages">
                {messages.map((m, i) => (
                    <p key={i} className={m.role}>{m.content}</p>
                ))}
            </div>
            <input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Ask me anything..."
            />
            <button onClick={sendMessage}>Send</button>
        </div>
    );
}
